import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構への提出確認",
];

//共通説明文

const infoManualRelationship1 = `
「死亡診断書」又は「死体検案書」（写）<`;

const infoManualRelationship2 = `
内縁関係についての「生計維持に関する調査書」（様式１１号）<`;

const infoManualRelationship3 = `
職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）<`;

const infoManualRelationship4 = `
職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）<`;

const infoManualRelationship5 = `
職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」< `;

const infoManualRelationship6 = `
その他、事実上の配偶者であることを証明する書類<`;

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "「死亡診断書」又は「死体検案書」（写）",
    keyword: "deathOrAutopsyReport",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: "1",
  },
  {
    title: "内縁関係についての「生計維持に関する調査書」（様式１１号）",
    keyword: "marriageReport",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: "2",
  },
  {
    title: "職員の死亡当時の世帯員の状況を明らかにできる「住民票の謄本」",
    keyword: "certifiedCertificateResidence",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,

    id: "3",
  },
  {
    title: "その他、事実上の配偶者であることを証明する書類",
    keyword: "documentCertifyingSpouse",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: "4",
  },
  {
    title:
      "職員の死亡当時、主として職員の収入により生計を維持していた親族がいることを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "yesLivelihoodInvestForm",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: "5",
  },
  {
    title:
      "職員の死亡当時、主として職員の収入により生計を維持していた親族がいないことを証する「生計維持に関する調査書」（様式１１号）",
    keyword: "noLivelihoodInvestForm",
    type: "fileUpload",
    requiredIcon: true,
    showLine: false,
    id: "6",
  },
];

const schema: any = {
  deathOrAutopsyReport: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  marriageReport: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  certifiedCertificateResidence: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  documentCertifyingSpouse: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  yesLivelihoodInvestForm: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  noLivelihoodInvestForm: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export {
  steps,
  infoManualRelationship1,
  infoManualRelationship2,
  infoManualRelationship3,
  infoManualRelationship4,
  infoManualRelationship5,
  infoManualRelationship6,
  fakeTableList,
  schema,
};
